import React from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaPhoneSquare, FaPhoneAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const inboundServices = [
    {
      icon: <FaPhone />,
      title: "Toll-Free Origination",
      description: "Reliable and scalable voice solutions designed to keep your communication efficient and cost-effective."
    },
    {
      icon: <FaPhone />,
      title: "Inbound Origination",
      description: "Seamless inbound call handling that ensures every customer interaction is smooth and professional."
    }
  ];

  const didServices = [
    {
      icon: <FaPhoneSquare />,
      title: "DID Services",
      description: "Direct Inward Dialing solutions that provide flexibility and control over your business telephony infrastructure."
    }
  ];

  const outboundServices = [
    {
      icon: <FaPhoneAlt />,
      title: "Toll-Free Termination",
      description: "High-quality termination services ensuring crystal-clear connections for all your toll-free communications."
    },
    {
      icon: <FaPhoneAlt />,
      title: "Wholesale Termination",
      description: "Cost-effective wholesale voice termination with global reach and premium quality for high-volume operations."
    },
    {
      icon: <FaPhoneAlt />,
      title: "Dialer Termination",
      description: "Optimized termination routes specifically designed for dialer systems with maximum efficiency and reliability."
    }
  ];

  return (
    <div className="services-container">
      <section className="services-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="services-main-title">Our Services</h1>
          </motion.div>
        </div>
      </section>

      {/* Inbound Section */}
      <section className="services-category">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="category-title">Inbound</h2>
            <div className="services-grid">
              {inboundServices.map((service, index) => (
                <motion.div
                  key={index}
                  className="service-item-card"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  {service.title === "Toll-Free Origination" ? (
                    <Link to="/toll-free-origination" className="service-link">
                      <div className="service-icon">{service.icon}</div>
                      <h3>{service.title}</h3>
                      <p>{service.description}</p>
                    </Link>
                  ) : service.title === "Inbound Origination" ? (
                    <Link to="/inbound-origination" className="service-link">
                      <div className="service-icon">{service.icon}</div>
                      <h3>{service.title}</h3>
                      <p>{service.description}</p>
                    </Link>
                  ) : (
                    <>
                      <div className="service-icon">{service.icon}</div>
                      <h3>{service.title}</h3>
                      <p>{service.description}</p>
                    </>
                  )}
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* DID Services Section */}
      <section className="services-category alt-bg">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="category-title">DID Services</h2>
            <div className="services-grid">
              {didServices.map((service, index) => (
                <motion.div
                  key={index}
                  className="service-item-card"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  {service.title === "DID Services" ? (
                    <Link to="/did-services" className="service-link">
                      <div className="service-icon">{service.icon}</div>
                      <h3>{service.title}</h3>
                      <p>{service.description}</p>
                    </Link>
                  ) : (
                    <>
                      <div className="service-icon">{service.icon}</div>
                      <h3>{service.title}</h3>
                      <p>{service.description}</p>
                    </>
                  )}
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Outbound Section */}
      <section className="services-category">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="category-title">Outbound</h2>
            <div className="services-grid">
              {outboundServices.map((service, index) => (
                <motion.div
                  key={index}
                  className="service-item-card"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  {service.title === "Toll-Free Termination" ? (
                    <Link to="/toll-free-termination" className="service-link">
                      <div className="service-icon">{service.icon}</div>
                      <h3>{service.title}</h3>
                      <p>{service.description}</p>
                    </Link>
                  ) : service.title === "Dialer Termination" ? (
                    <Link to="/dialer-termination" className="service-link">
                      <div className="service-icon">{service.icon}</div>
                      <h3>{service.title}</h3>
                      <p>{service.description}</p>
                    </Link>
                  ) : service.title === "Wholesale Termination" ? (
                    <Link to="/wholesale-termination" className="service-link">
                      <div className="service-icon">{service.icon}</div>
                      <h3>{service.title}</h3>
                      <p>{service.description}</p>
                    </Link>
                  ) : (
                    <>
                      <div className="service-icon">{service.icon}</div>
                      <h3>{service.title}</h3>
                      <p>{service.description}</p>
                    </>
                  )}
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Services;

